import { render, staticRenderFns } from "./ClienteFormStatus.vue?vue&type=template&id=4b7eb76c"
import script from "./ClienteFormStatus.vue?vue&type=script&lang=js"
export * from "./ClienteFormStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports